/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'GlobalStyles',
        import: () => import(/* webpackChunkName: 'GlobalStyles' */ '@stories/Widgets/Global/GlobalStyles/GlobalStyles'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'ArticleDetailSectionGlobalStyles',
        import: () => import(/* webpackChunkName: 'ArticleDetailSectionGlobalStyles' */ '@stories/Widgets/ArticleDetailSection/ArticleDetailSectionGlobalStyles'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'ContactFormGlobalStyles',
        import: () => import(/* webpackChunkName: 'ContactFormGlobalStyles' */ '@stories/Widgets/ContactForm/ContactForm.styles'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'KenticoForm',
        import: () => import(/* webpackChunkName: 'KenticoForm' */ '@stories/Components/Misc/Forms/KenticoForm/KenticoForm'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Header',
        import: () => import(/* webpackChunkName: 'Header' */ '@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Footer',
        import: () => import(/* webpackChunkName: 'Footer' */ '@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AnnouncementBar',
        import: () => import(/* webpackChunkName: 'AnnouncementBar' */ '@stories/Widgets/Global/AnnouncementBar/AnnouncementBar'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'CompactUSPSection',
        import: () => import(/* webpackChunkName: 'CompactUSPSection' */ '@stories/Widgets/CompactUSPSection/CompactUSPSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'USPBreakdownSection',
        import: () => import(/* webpackChunkName: 'USPBreakdownSection' */ '@stories/Widgets/USPBreakdownSection/USPBreakdownSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CityExplorerSection',
        import: () => import(/* webpackChunkName: 'CityExplorerSection' */ '@stories/Widgets/CityExplorerSection/CityExplorerSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FullWidthMediaSection',
        import: () => import(/* webpackChunkName: 'FullWidthMediaSection' */ '@stories/Widgets/FullWidthMediaSection/FullWidthMediaSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'BlogCards',
        import: () => import(/* webpackChunkName: 'BlogCards' */ '@stories/Widgets/BlogCards/BlogCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'LogoCards',
        import: () => import(/* webpackChunkName: 'LogoCards' */ '@stories/Widgets/LogoCards/LogoCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HTMLEmbedIntro',
        import: () => import(/* webpackChunkName: 'HTMLEmbedIntro' */ '@stories/Widgets/HTMLEmbed/HTMLEmbedIntro'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MemberRewardsSection',
        import: () => import(/* webpackChunkName: 'MemberRewardsSection' */ '@stories/Widgets/MemberRewardsSection/MemberRewardsSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ComparisonTable',
        import: () => import(/* webpackChunkName: 'ComparisonTable' */ '@stories/Widgets/ComparisonTable/ComparisonTable'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'OffersAndPromotionsCarousel',
        import: () => import(/* webpackChunkName: 'OffersAndPromotionsCarousel' */ '@stories/Widgets/OffersAndPromotionsCarousel/OffersAndPromotionsCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContentCards',
        import: () => import(/* webpackChunkName: 'ContentCards' */ '@stories/Widgets/ContentCards/ContentCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RichTextSection',
        import: () => import(/* webpackChunkName: 'RichTextSection' */ '@stories/Widgets/RichTextSection/RichTextSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HeroMediaSection',
        import: () => import(/* webpackChunkName: 'HeroMediaSection' */ '@stories/Widgets/HeroMediaSection/HeroMediaSection'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'PropertiesCarousel',
        import: () => import(/* webpackChunkName: 'PropertiesCarousel' */ '@stories/Widgets/PropertiesCarousel/PropertiesCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ApartmentsSection',
        import: () => import(/* webpackChunkName: 'ApartmentsSection' */ '@stories/Widgets/ApartmentsSection/ApartmentsSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContactUsContent',
        import: () => import(/* webpackChunkName: 'ContactUsContent' */ '@stories/Widgets/ContactForm/ContactUsContent/ContactUsContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InPageNavigation',
        import: () => import(/* webpackChunkName: 'InPageNavigation' */ '@stories/Widgets/InPageNavigation/InPageNavigation'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'StepByStepExplainer',
        import: () => import(/* webpackChunkName: 'StepByStepExplainer' */ '@stories/Widgets/StepByStepExplainer/StepByStepExplainer'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GallerySection',
        import: () => import(/* webpackChunkName: 'GallerySection' */ '@stories/Widgets/GallerySection/GallerySection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ApartmentsShowcase',
        import: () => import(/* webpackChunkName: 'ApartmentsShowcase' */ '@stories/Widgets/ApartmentsShowcase/ApartmentsShowcase'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TimelineSection',
        import: () => import(/* webpackChunkName: 'TimelineSection' */ '@stories/Widgets/TimelineSection/TimelineSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MediaAndText',
        import: () => import(/* webpackChunkName: 'MediaAndText' */ '@stories/Widgets/MediaAndText/MediaAndText'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SustainabilityBanner',
        import: () => import(/* webpackChunkName: 'SustainabilityBanner' */ '@stories/Widgets/SustainabilityBanner/SustainabilityBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MeetBobBanner',
        import: () => import(/* webpackChunkName: 'MeetBobBanner' */ '@stories/Widgets/MeetBobBanner/MeetBobBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleListing',
        import: () => import(/* webpackChunkName: 'ArticleListing' */ '@stories/Widgets/ArticleListing/ArticleListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Statistics',
        import: () => import(/* webpackChunkName: 'Statistics' */ '@stories/Widgets/Statistics/Statistics'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleDetailRichText',
        import: () => import(/* webpackChunkName: 'ArticleDetailRichText' */ '@stories/Widgets/ArticleDetailSection/Components/ArticleDetailRichText/ArticleDetailRichText'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleDetailMedia',
        import: () => import(/* webpackChunkName: 'ArticleDetailMedia' */ '@stories/Widgets/ArticleDetailSection/Components/ArticleDetailMedia/ArticleDetailMedia'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleDetailOutro',
        import: () => import(/* webpackChunkName: 'ArticleDetailOutro' */ '@stories/Widgets/ArticleDetailSection/Components/ArticleDetailOutro/ArticleDetailOutro'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PeopleCards',
        import: () => import(/* webpackChunkName: 'PeopleCards' */ '@stories/Widgets/PeopleCards/PeopleCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FilterableCityListing',
        import: () => import(/* webpackChunkName: 'FilterableCityListing' */ '@stories/Widgets/FilterableCityListing/FilterableCityListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SustainabilityInfographicSection',
        import: () => import(/* webpackChunkName: 'SustainabilityInfographicSection' */ '@stories/Widgets/SustainabilityInfographicSection/SustainabilityInfographicSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CuratedCustomerTestimonials',
        import: () => import(/* webpackChunkName: 'CuratedCustomerTestimonials' */ '@stories/Widgets/CuratedCustomerTestimonials/CuratedCustomerTestimonials'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AccordionSection',
        import: () => import(/* webpackChunkName: 'AccordionSection' */ '@stories/Widgets/AccordionSection/AccordionSection'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SearchModuleEmbedUtility',
        import: () => import(/* webpackChunkName: 'SearchModuleEmbedUtility' */ '@stories/Widgets/SearchModuleEmbed/Components/SearchModuleEmbedUtility'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'PropertyListing',
        import: () => import(/* webpackChunkName: 'PropertyListing' */ '@stories/Widgets/PropertyListing/PropertyListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ApartmentListing',
        import: () => import(/* webpackChunkName: 'ApartmentListing' */ '@stories/Widgets/ApartmentListing/ApartmentListing'),
        config: {
            hydrate: 'in-view',
        },
    },
];
